import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import reservationAdvertisementImage from '../../../containers/member/assets/img/ad-reservation-1.png';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';
import { asideColumnStyles } from '@/components/reservations/reservationLayoutStyles';

const PREFIX = 'BookTripSupport';

const classes = {
  helpBanner: `${PREFIX}-helpBanner`,
  helpBannerGradient: `${PREFIX}-helpBannerGradient`,
  helpInfo: `${PREFIX}-helpInfo`,
  helpInfoTitle: `${PREFIX}-helpInfoTitle`,
  helpInfoBody: `${PREFIX}-helpInfoBody`,
  helpInfoContactUs: `${PREFIX}-helpInfoContactUs`,
  helpInfoPhoneNumber: `${PREFIX}-helpInfoPhoneNumber`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.helpBanner}`]: {
    display: 'none',
    alignSelf: 'flex-start',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    // Size the banner like the benefits aside it stands in for on the portal: a
    // bare `flex: 1` only got what the form column's 360px basis left over, so
    // it stayed narrow on wide screens. It is hidden below `md`, so that is
    // where it starts acting as a column.
    ...asideColumnStyles(theme.breakpoints.values.md),
    flexDirection: 'column',
    backgroundImage: `url(${reservationAdvertisementImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'calc(724 / 1000 * 100%) calc(150 / 600 * 100%)',
    aspectRatio: '5/3',
  },
  [`& .${classes.helpBannerGradient}`]: {
    background: theme.palette.lightGrayToTransparentGradient.main,
    padding: theme.spacing(4),
  },
  [`& .${classes.helpInfo}`]: {
    marginRight: theme.spacing(18),
  },
  [`& .${classes.helpInfoTitle}`]: {
    fontFamily: 'Bitter',
    fontWeight: 700,
    fontSize: 36,
    lineHeight: '48px',
    letterSpacing: '0.5px',
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.helpInfoBody}`]: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 400,
    fontSize: 21,
    lineHeight: '30px',
    letterSpacing: '0.25px',
    marginBottom: theme.spacing(4),
  },
  [`& .${classes.helpInfoContactUs}`]: {
    fontFamily: 'Bitter',
    fontWeight: 700,
    fontSize: 18,
    padding: 0,
    lineHeight: '18px',
    letterSpacing: 0,
  },
  [`& .${classes.helpInfoPhoneNumber}`]: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: 21,
    paddingBottom: 0,
    paddingTop: theme.spacing(1),
    lineHeight: '113.99%',
    letterSpacing: '0.15px',
  },
}));

export default function BookTripSupport() {
  const t = useCommonTranslation();
  return (
    <StyledBox className={classes.helpBanner}>
      <Box className={classes.helpBannerGradient}>
        <Box className={classes.helpInfo}>
          <Typography className={classes.helpInfoTitle}>
            {t('member.supportTitle')}
          </Typography>
          <Typography className={classes.helpInfoBody}>
            {t('member.supportContent')}
          </Typography>
          <Typography className={classes.helpInfoContactUs}>
            {t('member.supportContactUs')}
          </Typography>
          <Typography className={classes.helpInfoPhoneNumber}>
            {t('member.supportPhoneNumber')}
          </Typography>
        </Box>
      </Box>
    </StyledBox>
  );
}
